/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
  // newImageSrc is the path of the new image in the same size as originalImage is sized.
  // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
  // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
  jQuery(mainImageDomEl).parents('a').attr('href', newImageSrc.replace('_grande', '_1024x1024'));
  jQuery(mainImageDomEl).attr('src', newImageSrc);  
};


jQuery(function($) {

  $(document).ready(function() {

    //CARGAR MÁS COLLECTION
    if ( $('.more').length ) {
      var wait = 0;
      var pInfScrLoading = false;
      var pInfScrDelay = 250;
      function pInfScrExecute() {
        pInfScrNode = $('.more').last();  
        pInfScrURL = $('.more a').last().attr("href");
        if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
          $.ajax({
            type: 'GET',
            url: pInfScrURL,
            beforeSend: function() {
              pInfScrLoading = true;
              pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src=\"http://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791\" />');
              pInfScrNode.hide();
            },
            success: function(data) {
              // remove loading feedback
              pInfScrNode.next().remove();
              pInfScrNode.remove();
              var filteredData = $(data).find(".collection-matrix");
              filteredData.insertBefore( $("#product-list-foot") );
              pInfScrLoading = false;
              attachClickEvent();
              wait=0;
            },
            dataType: "html"
          });

        }
      }
    }
    

    function attachClickEvent(){
      $(window).scroll(function(){
        if ( $('li.more').length ) {
          if ( ($(window).scrollTop() + $(window).height()) > $('li.more').offset().top ) {
            if ( wait == 0 ) {
              $( "li.more a" ).trigger( "click" );
              wait = 1;
            }
          }
        }
        
      });
      $('li.more a').on( 'click', function(event){
        if ( ($(window).scrollTop() + $(window).height()) > $('li.more').offset().top ) {
          pInfScrExecute();
          event.stopPropagation();
          return false;
        }
      });
    }
    attachClickEvent();



    //Image selector SWIPER
    var swiper = new Swiper('.swiper-container', {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        spaceBetween: 30,
    });
    if ( $('.swiper-wrapper').length ) {
      $('.swiper-container').css('height', $(window).width()*1.7);
    }
    $(window).resize(function(){
      if ( $('.swiper-wrapper').length ) {
        $('.swiper-container').css('height', $(window).width()*1.7);
      }
    });

    //LightBox Ajax botones telefono y chat
    $(document).on('click', '.telAjaxBtn.btnAjax', function(){
      $('body').removeClass('htmlAjax');
      $('body').removeClass('preHtmlAjax');
      $('body').addClass('llamaActive');
    });
    $(document).on('click', '.chatAjaxBtn.btnAjax', function(){
      $('body').removeClass('htmlAjax');
      $('body').removeClass('preHtmlAjax');
      $('#lc_chat_header').trigger('click');
    });
    //Auto Scroll con flecha Home
    $('img.arrowHome').click(function() {
      target = $(window).height();
      $('html, body').animate({
        scrollTop: target
      }, 1000);
    });


    //Centrado página producto
    $(window).load(function(){
      if ( $('body').hasClass('template-product') ) {
        $('#select-variant').css(
          {
            'right': ($(window).width() - $('.product').width())/2,
            'opacity': '1' 
          });
      }
    });
    $(window).resize(function(){
      if ( $('body').hasClass('template-product') ) {
        $('#select-variant').css({
            'right': ($(window).width() - $('.product').width())/2,
            'opacity': '1' 
          });
      }
    });
    

    //Hover Retailer

    $('.divS.retails, .textRetaila p').mouseleave(function(){
      $('.divSocial').removeClass('activo');
    });
    $('.divS.retails, .textRetaila p').mouseover(function(){
      $('.divSocial').addClass('activo');
    });


    //Hover suscribe + activar
    $('#subscribe input').mouseover(function(){
      $('#subscribe input').focus();
    });
    $('#subscribe input').mouseleave(function(){
      if ( $('#subscribe input').val() == '' ) {
        $('#subscribe input:focus').blur();
      }
    });
    $('#subscribe button').mouseover(function(){
      $(this).prev().focus();
    });
    $('#subscribe button').mouseleave(function(){
      if ( $('#subscribe input').val() == '' ) {
        $('#subscribe input:focus').blur();
      }
    });

    // Opacity on scroll Logo
    $(window).scroll(function() {
      var scrollTop = $(this).scrollTop();
      $('.headerCenter.logoSolo img').css({
        opacity: function() {
          var elementHeight = $(this).height() + 100;
          return 1 + (elementHeight - scrollTop) / elementHeight;
        }
      });
    });


    // Cookies Popup Help
    var popupYshey = getCookie('popupYshey');
    if ( popupYshey != 'cerrado' && $(window).width() >= 720 ) {
      $('.helpDiv').css('display', 'block');
    }
    $(window).resize(function() {
      if ( popupYshey != 'cerrado' && $(window).width() >= 720 ) {
        $('.helpDiv').css('display', 'block');
      } else {
        $('.helpDiv').css('display', '');
      }
    });

    // Cookies para Cuadro Cookies
    $('.aceptoCook').click(function(){
      $('body').removeClass('showCookies');
      creaCookie('popupCookies', 'cerrado', 15778500);
    });
    var popupCookies = getCookie('popupCookies');
    if ( popupCookies != 'cerrado' ) {
      $('body').addClass('showCookies');
    } else {
      $('body').removeClass('showCookies');
    }


    $(function() {
      $('.swatch :radio').change(function() {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        $(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');
      });
    });


    /* Coin selector con iconos */
    ordenCoin();
    function ordenCoin(){
      var currency_symbols = {
        'USD': '$', // US Dollar
        'EUR': '€', // Euro
        'CRC': '₡', // Costa Rican Colón
        'GBP': '£', // British Pound Sterling
        'ILS': '₪', // Israeli New Sheqel
        'INR': '₹', // Indian Rupee
        'JPY': '¥', // Japanese Yen
        'KRW': '₩', // South Korean Won
        'NGN': '₦', // Nigerian Naira
        'PHP': '₱', // Philippine Peso
        'PLN': 'zł', // Polish Zloty
        'PYG': '₲', // Paraguayan Guarani
        'THB': '฿', // Thai Baht
        'UAH': '₴', // Ukrainian Hryvnia
        'VND': '₫', // Vietnamese Dong
        'CNY': '¥',
      };

      $('.icon.conversor').html('');
      $('#conversorW .botones').html('');
      if ( $('#coin-container option').length ) {
        var simbInicial = currency_symbols[$('#coin-container option:selected').val()];

        $('.icon.conversor').append(
          '<i class="' + $('#coin-container option:selected').val().toLowerCase() + '" aria-hidden="true" data-valuecoin="'+ $("#coin-container option:selected").val() +'">'+simbInicial+'</i>'
        );
        /*$('.icon.conversor').append("<ul class='conversor'>");*/
        $('#coin-container option').each(function(){
          var simbolo = currency_symbols[$(this).val()] + ' ' + $(this).val();

          if ( $(this).val() != $('#coin-container option:selected').val() ) {
            $('#conversorW .botones').append('<a class="'+$(this).val().toLowerCase()+' boton" data-valuecoin="'+$(this).val()+'">'+simbolo+'</a>');
          } else {
            $('#conversorW .botones').append('<a class="'+$(this).val().toLowerCase()+' boton activo" data-valuecoin="'+$(this).val()+'">'+simbolo+'</a>');
          }
        });
      }
    }
    //Añade clase con coin selección
    $('body').addClass($('#coin-container select').val());

    //Cambia internamente coin
    $(document).on( 'click', '#conversorW .botones a', function(){
      $('body').removeClass('EUR');
      $('body').removeClass('GBP');
      $('body').removeClass('USD');
      $('body').addClass($(this).data('valuecoin'));
      $('body').removeClass('conversorW');
      Shoppad.$('#coin-container select').val($(this).data('valuecoin')).trigger('change');
      ordenCoin();
    });
/*
    console.log(window.Shoppad.apps.coin.getLocalCurrency());
*/


    /*
    $('body').click(function(){
      $('.apply_fee').trigger('click');
    });
    */

    $(function(){
      if ( $("#slides").length ) {
        $("#slides").slidesjs({
          width: 173,
          height: 334
        });
      }
    });


    /* Ancho Home header */
    if ( $('#shopify-section-header').length ) {
      $('#shopify-section-header').css('height', $(window).height() );
    }
    if ( $('.htmlAjaxDiv').length ) {
      $('.htmlAjaxDiv').css('height', $(window).height() * 1.5 );
    }
    

    $(window).resize(function(){
      if ( $('#shopify-section-header').length ) {
        $('#shopify-section-header').css('height', $(window).height() );
      }
      if ( $('.htmlAjaxDiv').length ) {
        $('.htmlAjaxDiv').css('height', $(window).height() * 1.5 );
      }
    });
    


    /* Movimientos scroll */
    $(document).scroll(function() {
      var scrollBottom = $(window).height() + $(document).scrollTop();
      var classBody;
      for (var i = $('.tobeanimatedUp').length - 1; i >= 0; i--) {
        var classBody = 'scrollItemUp' + [i];
        var tobeanimated = $('.tobeanimatedUp')[i];
        if ( scrollBottom > $(tobeanimated).offset().top ) {
          if ( ! $('body').hasClass(classBody) && ! $(tobeanimated).hasClass('animated') ) {
            var classBody = 'scrollItemUp' + [i];
            $('body').addClass(classBody);
            setTimeout(function(){
              for (var i = $('.tobeanimatedUp').length - 1; i >= 0; i--) {
                var classBody = 'scrollItemUp' + [i];
                var tobeanimated = $('.tobeanimatedUp')[i];
                $('body').removeClass(classBody);
              }
            }, 3000);
            $(tobeanimated).addClass('animated');
          }
        } else {
          if ( ! $('body').hasClass(classBody) ) {
            $(tobeanimated).removeClass('animated');
          }
        }
      }

      for (var i = $('.tobeanimatedLeft').length - 1; i >= 0; i--) {
        var classBody = 'scrollItemLeft' + [i];
        var tobeanimated = $('.tobeanimatedLeft')[i];
        if ( scrollBottom > $(tobeanimated).offset().top ) {
          if ( ! $('body').hasClass(classBody) && ! $(tobeanimated).hasClass('animated') ) {
            var classBody = 'scrollItemLeft' + [i];
            $('body').addClass(classBody);
            setTimeout(function(){
              for (var i = $('.tobeanimatedLeft').length - 1; i >= 0; i--) {
                var classBody = 'scrollItemLeft' + [i];
                var tobeanimated = $('.tobeanimatedLeft')[i];
                $('body').removeClass(classBody);
              }
            }, 3000);
            $(tobeanimated).addClass('animated');
          }
        } else {
          if ( ! $('body').hasClass(classBody) ) {
            $(tobeanimated).removeClass('animated');
          }
        }
      }

      for (var i = $('.tobeanimatedRight').length - 1; i >= 0; i--) {
        var classBody = 'scrollItemRight' + [i];
        var tobeanimated = $('.tobeanimatedRight')[i];
        if ( scrollBottom > $(tobeanimated).offset().top ) {
          if ( ! $('body').hasClass(classBody) && ! $(tobeanimated).hasClass('animated') ) {
            var classBody = 'scrollItemRight' + [i];
            $('body').addClass(classBody);
            setTimeout(function(){
              for (var i = $('.tobeanimatedRight').length - 1; i >= 0; i--) {
                var classBody = 'scrollItemRight' + [i];
                var tobeanimated = $('.tobeanimatedRight')[i];
                $('body').removeClass(classBody);
              }
            }, 3000);
            $(tobeanimated).addClass('animated');
          }
        } else {
          if ( ! $('body').hasClass(classBody) ) {
            $(tobeanimated).removeClass('animated');
          }
        }
      }

      for (var i = $('.tobeanimatedBott').length - 1; i >= 0; i--) {
        var classBody = 'scrollItemBott' + [i];
        var tobeanimated = $('.tobeanimatedBott')[i];
        if ( scrollBottom > $(tobeanimated).offset().top ) {
          if ( ! $('body').hasClass(classBody) && ! $(tobeanimated).hasClass('animated') ) {
            var classBody = 'scrollItemBott' + [i];
            $('body').addClass(classBody);
            setTimeout(function(){
              for (var i = $('.tobeanimatedBott').length - 1; i >= 0; i--) {
                var classBody = 'scrollItemBott' + [i];
                var tobeanimated = $('.tobeanimatedBott')[i];
                $('body').removeClass(classBody);
              }
            }, 3000);
            $(tobeanimated).addClass('animated');
          }
        } else {
          if ( ! $('body').hasClass(classBody) ) {
            $(tobeanimated).removeClass('animated');
          }
        }
      }


    });



    /* Checkout Update QTY disable duplicados */
    function disableInput (){
      if ( $('#your-shopping-cart').length ) {
        if ( $('.tablaEscritorio').css('display') == 'none' ) {
          for (var i = $('.tablaEscritorio .quantity').length - 1; i >= 0; i--) {
            var thss = $('.tablaEscritorio .quantity')[i];
            $(thss).attr('disabled', 'disabled');
            var thss = $('.tablaResponsive .quantity')[i];
            $(thss).removeAttr("disabled");
          }
        } else {
          for (var i = $('.tablaResponsive .quantity').length - 1; i >= 0; i--) {
            var thss = $('.tablaResponsive .quantity')[i];
            $(thss).attr('disabled', 'disabled');
            var thss = $('.tablaEscritorio .quantity')[i];
            $(thss).removeAttr("disabled");
          }
        }
      }
    }

    disableInput();
    $(window).resize(function(){ disableInput(); });


    /* HelpDesk */
    $('.helpDiv img.close').click(function(){
      $('.helpDiv').toggle();
      creaCookie('popupYshey', 'cerrado', 200);
    });

    $(document).on( 'click', '#lc_chat_layout', function(){
      $('img.helpImg').css('display', 'none');
    });


    $('.hasWindow').click(function(e){
      console.log(e);
      if ( $(this).siblings().find('.window') ) {
        $('body').removeClass('menuActive');
        $('#nav-icon4').removeClass('active');
        var titulo = $(this).find('.title').html();
        var contenido = $(this).find('.content').html();
        var imagen = '';
        if ( $(this).hasClass('img') ) {
          imagen = '<img class= "img" src="'+$(this).find('.window.img .img').data('url')+'">';
        }
        $('body').addClass('preHtmlAjax');
        setTimeout(function(){
          $('#htmlAjax').append('<img src="//yshey-development.myshopify.com/cdn/shop/t/2/assets/icon-seachx.svg?v=116096245503696411931496053961" class="close">');
          $('#htmlAjax').append('<h1 class="title">'+titulo+'</h1>');
          var clase = titulo.replace(/[!\"#$%&'\(\)\*\+,\.\/:;<=>\?\@\[\\\]\^`\{\|\}~áéíóúÁÉÍÓÚ?!¿¡]/g, '').replace(/\s/g, '');
          $('#htmlAjax').append('<div class=' + clase + '>' + contenido + '</div>');
          $('#htmlAjax .imgGif').append( imagen );
          $('body').addClass('htmlAjax');
        }, 100);
      }
      e.preventDefault();
    });

    // LIMPIAR STRING PARA USO DE CLASES
    function sanitize_title_with_dashes($title) {
        $title = strip_tags($title);
        // Preserve escaped octets.
        $title = preg_replace('|%([a-fA-F0-9][a-fA-F0-9])|', '---$1---', $title);
        // Remove percent signs that are not part of an octet.
        $title = str_replace('%', '', $title);
        // Restore octets.
        $title = preg_replace('|---([a-fA-F0-9][a-fA-F0-9])---|', '%$1', $title);

        if (seems_utf8($title)) {
            if (function_exists('mb_strtolower')) {
                $title = mb_strtolower($title, 'UTF-8');
            }
            $title = utf8_uri_encode($title, 200);
        }

        $title = strtolower($title);
        $title = preg_replace('/&.+?;/', '', $title); // kill entities
        $title = str_replace('.', '-', $title);
        $title = preg_replace('/[^%a-z0-9 _-]/', '', $title);
        $title = preg_replace('/\s+/', '-', $title);
        $title = preg_replace('|-+|', '-', $title);
        $title = trim($title, '-');

        return $title;
    }

    /* Páginas de lectura AJAX 
    $('.snippetFooter .icons a, .btn_add a.enlb, #shippingGuide').click(function(e){
      var urlAjax = e.currentTarget.href;

      $.getJSON( urlAjax, function(ajax) {
        if ( ajax.page.body_html != undefined ) {

          console.log(ajax);

          $('body').addClass('preHtmlAjax');
          setTimeout(function(){
            $('#htmlAjax').append('<img src="//yshey-development.myshopify.com/cdn/shop/t/2/assets/icon-seachx.svg?v=116096245503696411931496053961" class="close">');
            $('#htmlAjax').append('<h1 class="title">'+ajax.page.title+'</h1>');
            $('#htmlAjax').append(ajax.page.body_html);
            $('body').addClass('htmlAjax');
          }, 100);

        }
      });
      e.preventDefault();
    });
    */


    $('.htmlAjaxDiv').click(function(e){
      if ( e.target.className == 'htmlAjaxDiv' ) {
        $('body').removeClass('htmlAjax');
        setTimeout(function(){  
          $('body').removeClass('preHtmlAjax');
          $('body').removeClass('addBag');
          $('#htmlAjax').html('');
        }, 400);
      }
    });

    $(document).on( 'click', '.htmlAjaxDiv img.close', function(){
      $('body').removeClass('htmlAjax');
      setTimeout(function(){  
        $('body').removeClass('preHtmlAjax');
        $('body').removeClass('addBag');
        $('body').removeClass('conversorW');
        $('#htmlAjax').html('');
      }, 400);
    });



    $( window ).load(function() {
      /* Ajax del carrito */
      /*==========================*/
      $.ajax({ 
        type: 'GET',
        url: '/cart.json',
        dataType: 'jsonp',
        success: function(data) {
          var item_count = data['items'].length;

          //If there are items in cart
          if(item_count > 0) {
            // Hacemso un string para enviar Url  con productos al checkout directo
            var productos = '/cart/';
            for (i = 0; i < item_count; i++) {
              productos += data['items'][i].id + ':' + data['items'][i].quantity + ',';
              
            }
            productos = productos.slice(0, -1);
            if ( $('body').hasClass('espanol') ) {
              var nameVC = 'ver carrito';
            } else {
              var nameVC = 'view cart';
            }

            //Display total count
            var totalPrice = data['total_price'];


            $('#Bag .items').append('<img class="close" src="//yshey-development.myshopify.com/cdn/shop/t/2/assets/icon-seachx.svg?v=116096245503696411931496053961">');
            $('#Bag .items').append('<a class="viewCart" href="/cart">'+ nameVC +'</a>');
            for(var i=0;i<=item_count-1;i++){
              var product_title = data['items'][i]['title'];
              var productTitle = product_title.split('Top')[0];
              var productVariant = '';
              if ( product_title.split('Top')[1] != undefined ) {
                productVariant = 'Top' + product_title.split('Top')[1];
              }
              var productBolsita;
              if ( productTitle.includes("#YSHEYGirl set") ) {
                productBolsita = true;
              } else {
                productBolsita = false;
              }
              productTitle = productTitle.replace("-", "");
              var freeW = 'Free';
              if ( $('body').hasClass('espanol') ) {
                productTitle = productTitle.replace("Gift Box for", "Caja regalo para");
                freeW = 'Gratis';
              }
              var quantity = data['items'][i]['quantity'];
              var line_price = data['items'][i]['line_price'];
              var url = (data['items'][i]['url'] === 'undefined') ? '' : data['items'][i]['url'];
              url = 'href="' + url;
              if ( productBolsita == true ) {
                url = '';
              }

              var image_item = (data['items'][i]['image'] === 'undefined') ? '' : data['items'][i]['image'];
              var image_url = undefined;
              if ( image_item != undefined ) {
                image_url = data['items'][i]['image'].replace(/(\.jpg|\.png|\.jpeg|\.gif)/, '_small$1');
              }
              if ( productBolsita == true ) {
                $('#Bag .items').append('<hr><li class="cart_product"><a '+ url +'"><div class="thumb"><img src="'+ image_url +'"/></div><div class="product_description">'+ productTitle +'<span>'+ productVariant +'</span><br/><span class="xbag"></span><br/><span class="product-price money" itemprop="price">'+freeW+'</span></div></a></li><div style="clear:both;"></div>');
              } else {
                $('#Bag .items').append('<hr><li class="cart_product"><a '+ url +'"><div class="thumb"><img src="'+ image_url +'"/></div><div class="product_description">'+ productTitle +'<span>'+ productVariant +'</span><br/><span class="xbag">X</span> '+ quantity +' <br/><span class="product-price money" itemprop="price">'+addPrice(line_price)+'</span></div></a></li><div style="clear:both;"></div>');
              }
              
            }
            $('#bagCheckout').attr('href', productos);
            $('#Bag .total').html('<hr><div class="subTotal">TOTAL <span class="product-price" itemprop="price"><span class="money">'+addPrice(totalPrice)+ '</span></span></div>');

            $('body').addClass('bagFill');
            $('.itemCount').html(item_count);
          }

        }
      });
    });

    $('div#hideInput').mouseover(function(){
    	$('body').addClass('inputHide');
    });
    $('div#hideInput').mouseleave(function(){
    	$('body').removeClass('inputHide');
    });



    /* Bloqueo Add to bag */
    /* Si existen alguno de los Complete o Combination bloquea ahí, sino en Footer */
    var hasta;

    if ( $('.completeProd').length ) {
      hasta = $('.completeProd');
    } else if ( $('.combinationsProd').length ) {
      hasta = $('.combinationsProd');
    } else {
      hasta = $('.template-product footer');
    }

    $(document).scroll(function() {
      if ( $('.product-details').length ) {
        if ($('body.template-product .product-details').css('position') == 'fixed' || $('body.template-product .product-details').css('position') == 'absolute' ) {
          if ( $(document).scrollTop() > (hasta.offset().top - ($('.product-details').height() + 186)) ) {
            $('body').addClass('toBagAbsolute');
            $('.product-details').css('top', hasta.offset().top - ($('.product-details').height() + 100) );
          } else {
            $('body').removeClass('toBagAbsolute');
            $('.product-details').css('top', '' );
          }
        } else {
          $('body').removeClass('toBagAbsolute');
          $('.product-details').css('top', '' );
        }
      }
    });



    /*
    $(".icon.bag").click(function(e){
      if ( $('body').hasClass('bagFill') ) {
        $('body').removeClass('menuActive');
        $('body').removeClass('conversorW');
        $('body').removeClass('userW');
        $('#search-suggest').css('display', '');
        $('#nav-icon4').removeClass('open');
        $('body').removeClass('languageW');
        $('body').removeClass('userW');
        
        $('body').toggleClass('bagAjax');
        $('#Bag').css({
          'top': ($(document).scrollTop() + 72) + 'px',
          'left': ($('.icon.bag').offset().left - 216) + 'px'
        });
      }
    });
    */
    $(document).on('click', '.close', function(){
      $('body').removeClass('bagAjax');
      $('body').removeClass('userW');
      $('body').removeClass('languageW');
      $('body').removeClass('conversorW');
    });

    $(window).resize(function() {
      if ( $('#Bag').length ) {
        $('#Bag').css({
          'top': ($(document).scrollTop() + 72) + 'px',
          'left': ($('.icon.bag').offset().left - 216) + 'px'
        });
      }
    });
    



    $(document).scroll(function() {
      if ( $('.campos').length ) {
        if ( $(document).scrollTop() > 30 && 
          $(document).scrollTop() < $('#shopify-section-shopInstagram').offset().top ) {
          $('body').addClass('fijoFilter');
        } else {
          $('body').removeClass('fijoFilter');
        }
      }
    });

    /* Header: Menu, Hamburguesa, iconos derecha */
    /*==========================*/

    if ($(document).scrollTop() <= ($('#shopify-section-header').height() - ($('#shopify-section-header').height()/2 - 100 ) ) && $('#shopify-section-header').length > 0) {
      if ( $('#shop-instagram').length || $('#campaign').length ) {
      } else {
          $('body').addClass('blancoHeader');
      }
    } else if ( $(document).scrollTop() > ($('#shopify-section-header').height() - ($('#shopify-section-header').height()/2 - 100 ) ) && $('#shopify-section-header').length > 0 ) {
      $('body').addClass('bajaHeader');
    }

    $(document).scroll(function() {
      if ($(document).scrollTop() <= ($('#shopify-section-header').height() - ($('#shopify-section-header').height()/2 - 100 ) ) && $('#shopify-section-header').length > 0) {
        $('body').addClass('blancoHeader');
        $('body').removeClass('bajaHeader');
      } else {
        if ( $('#shop-instagram').length || $('#campaign').length ) {
        } else {
          $('body').addClass('bajaHeader');
          $('body').removeClass('blancoHeader');
        }
        
      }
    });
    var entra = false;
    var transicion = false;
    var transicionCierre = false;
    $('#nav-icon4').click(function(){
      if ( transicion == false ) {
        transicionCierre = true;
        setTimeout(function(){
          transicionCierre = false;
        }, 800);
        $(this).toggleClass('open');
        $('body').removeClass('searchActive');
        $('#search-suggest').css('display', '');
        $('body').toggleClass('menuActive');
      }
    });
    $('#nav-icon4').mouseover(function(){
      if ( $(window).width() > 700 && ! $(this).hasClass('open') ) {
          transicion = true;
          setTimeout(function(){
            transicion = false;
          }, 400);
          if ( transicionCierre == false ) {
            $(this).addClass('open');
            $('body').removeClass('searchActive');
            $('#search-suggest').css('display', '');
            $('body').addClass('menuActive');
          }
      }
    });

    $('.header-top-icons .icon').click(function(){
      /* Al hacer click en cada icono, desactiva el anterior y hace toggle al nuevo */
      var onlythis = false;
      if ( $(this).hasClass('active') ) { var onlythis = true; }
      $('.header-top-icons .icon').removeClass('active');
      if ( onlythis == true ) {
        if ( $(this).hasClass('search') ) { 
          $('body').removeClass('searchActive');
          $('#search-suggest').css('display', '');
        }
        $(this).removeClass('active');
      } else {
        if ( $(this).hasClass('search') ) {
          setTimeout(function(){
            $('#search_input').focus();
          },1000);
          $('#nav-icon4').removeClass('open');
          $('body').addClass('searchActive');
          $('body').removeClass('menuActive');
          if ( $('#search_input').val() ) {
            $('#search-suggest').css('display', 'none');
          }
        }
        $(this).addClass('active');
      }
    });
    $('#search_input').keydown(function(){
      $('#search-suggest').css('display', 'none');
    });
   
    $('.has-dropdown').click(function(e){
      if (e.target.href == 'https://yshey.com/#'){
        e.preventDefault();
      }
    });

    $('.htmlAjaxDiv').click(function(){
      if ( $('body').hasClass('searchActive') || $('body').hasClass('menuActive') ) {
        $('body').removeClass('menuActive');
        $('body').removeClass('searchActive');
        $('#search-suggest').css('display', '');
        $('#nav-icon4').removeClass('open');
        $('.header-top-icons .icon').removeClass('active');
      }
    });

    if ( $(window).width() <= 985 ) {
      if ($('.menu-principal').length) {
        $('.menu-principal').css('height', ($(window).height() - 70) + 'px');
      }
    }


    /* Damos clase a body de "iconos menu movil abajo"   */
    if ( $('#menuAct').css('display') != 'none' ) {
      $('body').addClass('menuMvlIcons');
    }

    $(window).resize(function() {
      
      if ($('.menu-principal').length) {
        if ( $(window).width() <= 985 ) {
          $('.menu-principal').css('height', ($(window).height() - 70) + 'px' );

        } else {
          $('.menu-principal').css('height', '');
        }
      }

      /* Damos clase a body de "iconos menu movil abajo"   */
      if ( $('#menuAct').css('display') != 'none' ) {
        $('body').addClass('menuMvlIcons');
      } else {
        $('body').removeClass('menuMvlIcons');
      }

    });

    $('.icon.user').click(function(){
      $('body').removeClass('menuActive');
      $('body').removeClass('searchActive');
      $('#search-suggest').css('display', '');
      $('body').removeClass('languageW');
      $('body').removeClass('bagAjax');
      $('#nav-icon4').removeClass('open');
      $('body').removeClass('conversorW');

      $('body').toggleClass('userW');
      if ( $('body').hasClass('menuMvlIcons') ){
        $('#userW').css({
          'top': ($(document).scrollTop() + 72) + 'px',
          'left': ''
        });
      } else {
        $('#userW').css({
          'top': ($(document).scrollTop() + 72) + 'px',
          'left': ($('.icon.bag').offset().left - 190) + 'px'
        });
      }
    });
    $(window).resize(function() {
      if ( $('#userW').length ) {
        if ( $('body').hasClass('menuMvlIcons') ){
          $('#userW').css({
            'top': ($(document).scrollTop() + 72) + 'px',
            'left': ''
          });
        } else {
          $('#userW').css({
            'top': ($(document).scrollTop() + 72) + 'px',
            'left': ($('.icon.bag').offset().left - 190) + 'px'
          });
        }
      }
    });
    $('.icon.language').click(function(){
      $('body').removeClass('menuActive');
      $('body').removeClass('userW');
      $('body').removeClass('searchActive');
      $('#search-suggest').css('display', '');
      $('body').removeClass('bagAjax');
      $('#nav-icon4').removeClass('open');
      $('body').removeClass('conversorW');

      $('body').toggleClass('languageW');
      if ( $('body').hasClass('menuMvlIcons') ){
        $('#languageW').css({
          'top': ($(document).scrollTop() + 72) + 'px',
          'left': ''
        });
      } else {
        $('#languageW').css({
          'top': ($(document).scrollTop() + 72) + 'px',
          'left': ($('.icon.bag').offset().left - 155) + 'px'
        });
      }
    });
    $(window).resize(function() {
      if ( $('#languageW').length ) {
        if ( $('body').hasClass('menuMvlIcons') ){
          $('#languageW').css({
            'top': ($(document).scrollTop() + 72) + 'px',
            'left': ''
          });
        } else {
          $('#languageW').css({
            'top': ($(document).scrollTop() + 72) + 'px',
            'left': ($('.icon.bag').offset().left - 155) + 'px'
          });
        }
      }
    });

    $('.icon.conversor').click(function(){
      $('body').removeClass('menuActive');
      $('body').removeClass('userW');
      $('body').removeClass('searchActive');
      $('#search-suggest').css('display', '');
      $('body').removeClass('bagAjax');
      $('#nav-icon4').removeClass('open');
      $('body').removeClass('languageW');
      $('body').toggleClass('conversorW');

      if ( $('body').hasClass('menuMvlIcons') ){
        $('#conversorW').css({
          'top': ($(document).scrollTop() + 72) + 'px',
          'left': ''
        });
      } else {
        $('#conversorW').css({
          'top': ($(document).scrollTop() + 72) + 'px',
          'left': ($('.icon.bag').offset().left - 180) + 'px'
        });
      }
    });
    $(window).resize(function() {
      if ( $('#conversorW').length ) {
        if ( $('body').hasClass('menuMvlIcons') ){
          $('#conversorW').css({
            'top': ($(document).scrollTop() + 72) + 'px',
            'left': ''
          });
        } else {
          $('#conversorW').css({
            'top': ($(document).scrollTop() + 72) + 'px',
            'left': ($('.icon.bag').offset().left - 180) + 'px'
          });
        }
      }
    });


    $('.llama').click(function(){
      $('body').toggleClass('llamaActive');
    });


    function creaCookie(name, value, time) {
       var date = new Date();
       date.setTime(date.getTime()+(time*1000));
       var expires = "; expires="+date.toGMTString();
       document.cookie = name+"="+value+expires+"; path=/";
    }
    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }



    // Fancybox
    
      $('.flash').fancybox();
      $(".fancybox").fancybox({
        openEffect  : 'fade', /* none, fade, elastic */
        closeEffect : 'fade',
        openSpeed :  1000, /* ms, "slow", "normal", "fast"*/
        closeSpeed : 1000,
        /* mouseWheel : false,*/
        helpers : {
          /*title : null */
          title : {
            type : 'inside' /* 'float', 'inside', 'outside', 'over', 'null' */
          }
        }
      });
      $(".fancybox-iframe").fancybox({
        scrolling : 'auto',
        width: 1200,
        /* preload   : true*/
      });


    /* Section Instagram */
    $('.moduloInstagram .insta').mouseover(function(){
      $(this).addClass('over');
    });
    $('.moduloInstagram .insta').mouseleave(function(){
      $(this).removeClass('over');
    });





    // SLIDE FOTOS HOME
    /*==========================*/

      var images_des = $( '.fotos-escritorio img' ).length;
      var fotoTipo = '.fotos-escritorio';
      if ($('#shopify-section-header').length) {
        if ( $(window).width() <= 500 ) {
          fotoTipo = '.fotos-escritorio-movil';
          images_des = $( '.fotos-escritorio-movil img' ).length;
        }
      }
      $(window).resize(function() {
        if ($('#shopify-section-header').length) {
          if ( $(window).width() <= 500 ) {
            images_des = $( '.fotos-escritorio-movil img' ).length;
          } else {
            images_des = $( '.fotos-escritorio img' ).length;
            fotoTipo = '.fotos-escritorio';
          }
        }
      });
      

      var foto_num = 0;


      // Suma y reinicia el contador dependiendo de las fotos que haya.
      function contador() {

        foto_num++;

        if ( foto_num > images_des ) {

          foto_num = 1;

        }

      }

      //llama al primer contador
      cambiofoto1();
      $( '.imagen-home' ).addClass( 'activo' );

        
      $( '.imagen-home' ).css( 'background-image', 'url(' + $( fotoTipo + ' img:nth-child(1)'  ).attr('src') + ')' );
      $( '.imagen-home2' ).css( 'background-image', 'url(' + $( fotoTipo + ' img:nth-child(2)'  ).attr('src') + ')' );
      $('.headIndividuales:nth-child(1)').addClass( 'activeHead' );

    

      function cambiofoto1() {

        contador();

        if ( $( '.imagen-home' ).hasClass( 'activo' ) ) { var clase = '.imagen-home'; } else { var clase = '.imagen-home2'; }

        setTimeout(function() {
          
          $( 'body' ).addClass( 'blanco' );
          setTimeout(function() {
            $( 'body' ).removeClass( 'blanco' );
            if ( $( '.imagen-home' ).hasClass( 'activo' ) ) { 
              $( '.imagen-home' ).removeClass( 'activo' );
              $( '.imagen-home2' ).addClass( 'activo' );
            } else {
              $( '.imagen-home2' ).removeClass( 'activo' );
              $( '.imagen-home' ).addClass( 'activo' );
            }
              
            $( clase ).css( 'background-image', 'url(' + $( fotoTipo + ' img:nth-child(' + foto_num + ')'  ).attr('src') + ')' );
            
            for (var i = $('.headIndividuales').length - 1; i >= 0; i--) {
              var divHead = $('.headIndividuales')[i];
              $(divHead).removeClass('activeHead');
            }
            $('.headIndividuales:nth-child(' + foto_num + ')').addClass( 'activeHead' );

          }, 2000);

          cambiofoto2();

        }, 5000);
      }

      function cambiofoto2() {

        contador();

        if ( $( '.imagen-home' ).hasClass( 'activo' ) ) { var clase = '.imagen-home'; } else { var clase = '.imagen-home2'; }

        setTimeout(function() {

          $( 'body' ).addClass( 'blanco' );
          setTimeout(function() {
            $( 'body' ).removeClass( 'blanco' );
            if ( $( '.imagen-home' ).hasClass( 'activo' ) ) { 
              $( '.imagen-home' ).removeClass( 'activo' );
              $( '.imagen-home2' ).addClass( 'activo' );
            } else {
              $( '.imagen-home2' ).removeClass( 'activo' );
              $( '.imagen-home' ).addClass( 'activo' );
            }
            $( clase ).css( 'background-image', 'url(' + $( fotoTipo + ' img:nth-child(' + foto_num + ')'  ).attr('src') + ')' );
            
            for (var i = $('.headIndividuales').length - 1; i >= 0; i--) {
              var divHead = $('.headIndividuales')[i];
              $(divHead).removeClass('activeHead');
            }
            $('.headIndividuales:nth-child(' + foto_num + ')').addClass( 'activeHead' );

          }, 2000);
          cambiofoto1();

        }, 5000);
      }





    /* Placeholder JS */
    /*==========================*/
    var test = document.createElement('input');
    if (!('placeholder' in test)) {
      $('[placeholder]').each(function(){
        if ($(this).val() === '') {
          var hint = $(this).attr('placeholder');
          $(this).val(hint).addClass('hint');
        }
      });
      $('[placeholder]').focus(function() {
        if ($(this).val() === $(this).attr('placeholder')) {
          $(this).val('').removeClass('hint');
        }
      }).blur(function() {
        if ($(this).val() === '') {
          $(this).val($(this).attr('placeholder')).addClass('hint');
        }
      });    
    }

    /* Form validation JS */
    /*==========================*/

    $('input.error, textarea.error').focus(function() {
      $(this).removeClass('error');
    });

    $('form :submit').click(function() {
      $(this).parents('form').find('input.hint, textarea.hint').each(function() {
        $(this).val('').removeClass('hint');
      });
      return true;
    });
    
    /* Remove SVG images to avoid broken images in all browsers that don't support SVG. */
    /*==========================*/
    
    var supportsSVG = function() {
      return document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#Image', '1.1');
    }  
    if (!supportsSVG()) {
      $('img[src*=".svg"]').remove();
    }
    
    /* Prepare to have floated images fill the width of the design on blog pages on small devices. */
    /*==========================*/ 
      
    var images = $('.article img').load(function() {
      var src = $(this).attr('src').replace(/_grande\.|_large\.|_medium\.|_small\./, '.');
      var width = $(this).width();
      $(this).attr('src', src).attr('width', width).removeAttr('height');
    });
    
    /* Update main product image when a thumbnail is clicked. */
    /*==========================*/
    $('.product-photo-thumb a').on('click', function(e) { 
      e.preventDefault();
      switchImage($(this).attr('href'), null, $('.product-photo-container img')[0]);
    } );
    
  });
});